import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../../services/storage/storage';
import { inject } from '@angular/core';
import { ToastService } from '../../services/toast/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { DecodedTokenI } from '../../../views/shared/interfaces/decoded-token.interface';
import { checkNullability } from '../../../views/shared/utils/nullability.util';

export const authenticationGuard: CanActivateFn = (route, _state) => {
  const {} = route;
  const storageService = inject(StorageService);
  const router = inject(Router);
  const toastService = inject(ToastService);
  const translateService = inject(TranslateService);

  const token = storageService.accessToken;

  if (!checkNullability(token)) {
    toastService.showError(translateService.instant('auth.errors.login'));
    router.navigate(['auth/login']);
    return false;
  }

  let decodedToken: DecodedTokenI;
  try {
    const stringifiedDecodedToken = atob(token!.split('.')[1]);
    decodedToken = JSON.parse(stringifiedDecodedToken);
  } catch (error) {
    toastService.showError(translateService.instant('auth.errors.notJwtToken'));
    router.navigate(['auth/login']);
    return false;
  }

  const expired = Math.floor(new Date().getTime() / 1000) >= decodedToken.exp;

  if (expired) {
    toastService.showError(translateService.instant('auth.errors.sessionExp'));
    router.navigate(['auth/login']);
    return false;
  }

  return true;
};
